<form [formGroup]="form" *ngIf="form && controlName">
  <mat-form-field appearance="outline" floatLabel="always" class="form-field">
    <mat-label *ngIf="label">Select {{ label }}</mat-label>
    <input
      type="text"
      [placeholder]="placeholder + ' ...'"
      matInput
      [matAutocomplete]="auto"
      [formControlName]="controlName"
      [attr.aria-label]="placeholder"
    />
    <mat-autocomplete
      [displayWith]="displayFn"
      #auto="matAutocomplete"
      (optionSelected)="onFormSelected($event.option.value)"
    >
      <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
        {{ option.title }}
      </mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="form.get(controlName).hasError('invalidAutocomplete')"> Invalid {{ label }} name </mat-error>
    <mat-error *ngIf="form.get(controlName).hasError('required') && form.get(controlName).touched">
      {{ label ?? 'This field' }} is required
    </mat-error>
  </mat-form-field>
</form>
